export default '/build/c952b699.svg'